 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTHALFTITLE from '@/components/Text/halftitle'
 import TEXTPHOTO from '@/components/Text/photo'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTPREFACE from '@/components/Text/preface'
 import TEXTHALFTITLE1 from '@/components/Text/halftitle1'
 import TEXTCHAPTER1 from '@/components/Text/chapter1'
 import TEXTCHAPTER2 from '@/components/Text/chapter2'
 import TEXTCHAPTER3 from '@/components/Text/chapter3'
 import TEXTCHAPTER4 from '@/components/Text/chapter4'
 import TEXTCHAPTER5 from '@/components/Text/chapter5'
 import TEXTCHAPTER6 from '@/components/Text/chapter6'
 import TEXTCHAPTER7 from '@/components/Text/chapter7'
 import TEXTCHAPTER8 from '@/components/Text/chapter8'
 import TEXTCHAPTER9 from '@/components/Text/chapter9'
 import TEXTCHAPTER10 from '@/components/Text/chapter10'
 import TEXTCHAPTER11 from '@/components/Text/chapter11'
 import LOVE_2 from '@/components/love_2'
 import TEXTACKNOWLEDGEMENT from '@/components/Text/acknowledgement'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTBIBLIOGRAPHY from '@/components/Text/bibliography'
 import TEXTPHOTOCREDIT from '@/components/Text/photocredit'
 import TEXTNOTEONTHETYPE from '@/components/Text/noteonthetype'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/preface",
 			"name" : "Text/preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/halftitle1",
 			"name" : "Text/halftitle1",
 			"component" : TEXTHALFTITLE1
 		},
 		{
 			"path" : "/Text/chapter1",
 			"name" : "Text/chapter1",
 			"component" : TEXTCHAPTER1
 		},
 		{
 			"path" : "/Text/chapter2",
 			"name" : "Text/chapter2",
 			"component" : TEXTCHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js